/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Loginsettings1Inputs */

const en_entity_loginsettings1 = /** @type {(inputs: Entity_Loginsettings1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login Settings`)
};

const de_entity_loginsettings1 = /** @type {(inputs: Entity_Loginsettings1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login-Einstellungen`)
};

/**
* | output |
* | --- |
* | "Login Settings" |
*
* @param {Entity_Loginsettings1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_loginsettings1 = /** @type {((inputs?: Entity_Loginsettings1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Loginsettings1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_loginsettings1(inputs)
	return de_entity_loginsettings1(inputs)
});
export { entity_loginsettings1 as "entity_loginSettings" }